import { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "../Dicas/styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

export function Dicas() {
  // Get today's date in dd/mm/yyyy format
  const getTodayDate = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const [fontes, setFontes] = useState(["Diário Eletrônico do MPMA"]);
  const [ultimaAtualizacao, setUltimaAtualizacao] = useState(getTodayDate());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch data from both APIs
    const fetchData = async () => {
      try {
        setLoading(true);

        // Fetch fontes
        const fontesResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/listar-fontes-em-uso`);
        const fontesData = await fontesResponse.json();

        // Fetch última atualização
        const atualizacaoResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/ultima-atualizacao`);
        const atualizacaoData = await atualizacaoResponse.json();

        setFontes(fontesData.fontes || []);
        setUltimaAtualizacao(atualizacaoData.ultima_atualizacao || "");
      } catch (err) {
        setError(err.message);
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <Row>
        <Col>
          <Card className="Dicas">
            <Card.Header>
              <h5>Dicas de pesquisa</h5>
            </Card.Header>
            <Card.Body>
              <ul>
                <li>
                  Insira os termos de pesquisa e clique no botão{" "}
                  <strong>PESQUISAR</strong>. A busca irá retornar todos os
                  documentos que contiverem quaisquer das palavras inseridas{" "}
                </li>

                <li>
                  É possível realizar buscas por expressão exata inserindo os termos
                  entre aspas duplas: <br />
                  <span className={`mt-2 d-block fst-italic`}>Ex.:”gestão de documentos”</span>
                </li>

                <li>
                  Para refinar os resultados, você pode usar os seguintes filtros:
                  Órgão de origem, Tipo de norma, Assunto, Ano, Período de
                  publicação e Número.
                  <br />
                  <span className={`mt-2 d-block fst-italic`}>
                    Exemplo: selecione o tipo “Ato Regulamentar” e o ano “2022” e
                    clique no botão <strong>FILTRAR</strong>. Serão retornados todos
                    os Atos Regulamentares de 2022.
                  </span>
                </li>

                <li>
                  Os resultados das buscas podem ser ordenados de três formas:
                </li>
                <ul>
                  <li>
                    Por <span className="text-decoration-underline">relevância</span>: quando os documentos são
                    classificados pela quantidade de ocorrência dos termos de
                    pesquisa encontrados em seu conteúdo, em ordem decrescente;
                  </li>
                  <li>
                    Por <span className="text-decoration-underline">publicação decrescente</span>: os documentos são
                    classificados pela data de publicação, em ordem decrescente;
                  </li>
                  <li>
                    Por <span className="text-decoration-underline">publicação crescente</span>: os documentos são
                    classificados pela data de publicação, em ordem crescente.
                  </li>
                </ul>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <div className="mt-3">
          {loading && <p className="fs-8 fst-italic">Carregando...</p>}
          {error && (
            <p className="text-warning">
              <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
            </p>
          )}
          <p className="fs-8">Última atualização: <strong>{ultimaAtualizacao}</strong><br />
            Fonte(s): <strong>{fontes.join(", ")}</strong></p>
        </div>
      </Row>
    </>
  );
}